module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "chooseBtn btn tertiary d-flex flex-column",
    class: {
      'border-color-1': _vm.value
    },
    on: {
      "click": function($event) {
        return _vm.setButton(true)
      }
    }
  }, [_c('span', {
    staticClass: "mb-2 bold"
  }, [_vm._v("Invite an Agent")]), _vm._v(" "), _c('span', {
    staticClass: "fs-smallest"
  }, [_vm._v("Less time on phone calls, Send a login so your agents can enter into the community")])]), _vm._v(" "), _c('div', {
    staticClass: "chooseBtn btn tertiary d-flex flex-column",
    class: {
      'border-color-1': !_vm.value
    },
    on: {
      "click": function($event) {
        return _vm.setButton(false)
      }
    }
  }, [_c('span', {
    staticClass: "mb-2 bold"
  }, [_vm._v("Create Private Agent")]), _vm._v(" "), _c('span', {
    staticClass: "fs-smallest"
  }, [_vm._v("Create a offline internal profile. More time with phone calls.")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-44cd461e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cd461e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentNewSelector.vue
// module id = 1220
// module chunks = 0